<template>
  <ValidationProvider
    v-slot="{ errors }"
    class="upload-file-list"
    :rules="rules"
    :class="{'flex-auto':flexAuto}"
  >
    <input
      type="hidden"
      :value="attaches"
    >
    <p
      v-if="title"
      class="upload-file-list_title"
    >
      {{ $t(title) }}<span
        v-if="required"
        class="red"
      >*</span>
    </p>
    <div
      class="upload-file-list_content"
      :class="{mobileRow:mobileRow}"
    >
      <div
        v-for="(attache_e,atteche_k) in attaches"
        :key="atteche_k"
        class="upload-file-item"
      >
        <FileDownloadButton
          v-if="!attache_e.url"
          :text-label="attache_e"
          :num="atteche_k"
          :upload="upload"
          :download="download"
          :show-delete-btn="showDeleteBtn"
          :isloading="attache_e.isloading"
          @deleteFile="$_deleteFile(atteche_k)"
        />
        <FileDownloadButton
          v-else
          :text-label="attache_e.url"
          :num="atteche_k"
          :upload="upload"
          :download="download"
          :show-delete-btn="showDeleteBtn"
          :isloading="attache_e.isloading"
          @deleteFile="$_deleteFile(atteche_k)"
        />
      </div>
      <div
        v-if="$_oneFileAdjust()"
        class="upload-button"
      >
        <UploadFileButton
          v-model="attaches"
          :upload-url="uploadUrl"
          :multiple="multiple"
          :factory="factory"
          :text-label="buttonText"
          :remind-text="remindText"
          :url="url"
          :moduleName="moduleName"
        />
      </div>
      <div
        v-if="errors.length > 0"
        class="invalid-text"
      >
        <i class="icon-warning invalid-icon" />
        <p
          v-for="(text_e,text_k) in errors"
          :key="text_k"
          class="text"
        >
          {{ $t(text_e) }}
        </p>
      </div>
    </div>
  </ValidationProvider>
</template>
<script>
import { ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "此項目為必填",
});
export default {
  name: "UploadFileList",
  components: {
    ValidationProvider,
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    uploadUrl: {
      type: String,
      default: "",
    },
    upload: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default() {
        return this.$t("附件");
      },
    },
    factory: {
      type: String,
    },
    mobileRow: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: "",
    },
    oneFile: {
      type: Boolean,
      default: false,
    },
    remindText: {
      type: String,
      default() {
        return this.$t("檔案大小限制") + "≤ 30 MB";
      },
    },
    rules: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    flexAuto: {
      type: Boolean,
      default: false,
    },
    download: {
      type: Boolean,
      default: true,
    },
    showDeleteBtn: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
    },
    moduleName :{
      type: String,
    },
  },
  data: () => ({
    attaches: [],
  }),
  watch: {
    attaches() {
      this.$emit("input", this.attaches);
    },
    value() {
      this.attaches = this.value;
    },
  },
  mounted() {
    this.attaches = this.value;
  },
  methods: {
    $_deleteFile(index) {
      this.attaches.splice(index, 1);
    },
    $_oneFileAdjust() {
      if (this.oneFile && this.attaches.length === 1) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/upload-file-list";
</style>